import { render, staticRenderFns } from "./personnel_edit.vue?vue&type=template&id=06ce4cca&scoped=true&"
import script from "./personnel_edit.vue?vue&type=script&lang=js&"
export * from "./personnel_edit.vue?vue&type=script&lang=js&"
import style0 from "./personnel_edit.vue?vue&type=style&index=0&id=06ce4cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce4cca",
  null
  
)

export default component.exports